import React, { useState, useEffect } from 'react';

export default function EntryItemCheckbox({item, handleSelect}) {

  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    if (typeof(item.editable) != "undefined") {
      if (!item.editable) {
        setDisabled(true)
      }
    }

    if (item.deleting) {
      setDisabled(true)
    }
  }, [item])

  return (
    <div className="check_blog">
      <input
        type="checkbox" id={"inpCheck" + item.id} className="inp_check"
        onChange={handleSelect}
        checked={item.selected}
        disabled={disabled}
      />
      <label htmlFor={"inpCheck" + item.id} className="ico_blog ico_checkbox">
        선택 {item.selected? "됨" : "안됨"}
      </label>
    </div>
  )
}
